import React, { SVGProps, useRef, useEffect, useState } from 'react'
import { SwashbuckleComponentProps } from '../../types'
import { dynamicallyImportIcon } from '../../../utils/dynamicIcons'

type SVGIconProps = SVGProps<SVGElement>

interface IconProps extends SwashbuckleComponentProps, SVGIconProps {
  name: string
}

export const Icon = ({
  name,
  'data-qa': dataQa,
  className,
  'aria-hidden': ariaHidden = true,
  ...restProps
}: IconProps) => {
  const ImportedIconRef = useRef<React.FC<SVGIconProps>>()

  // Need this to force a re-render once the icon has been dynamically imported
  const [_, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    const loadIcon = async () => {
      try {
        ImportedIconRef.current = (
          await dynamicallyImportIcon(name)
        ).ReactComponent
      } catch (err) {
        console.error(`Could not import icon with name "${name}"`)
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
    loadIcon()
  }, [name])

  const SvgIcon = ImportedIconRef.current

  if (SvgIcon) {
    return (
      <SvgIcon
        data-qa={dataQa}
        className={className}
        aria-hidden={ariaHidden}
        {...restProps}
      />
    )
  }

  return null
}

Icon.displayName = 'Icon'
